import Form, { formCreate } from '@/found/components/form';
import ProductRespVos from './product_list.vue';
import PhotoRespVos from './photo_list.vue';

formCreate.component('ProductRespVos', ProductRespVos);
formCreate.component('PhotoRespVos', PhotoRespVos);

export default {
  name: 'table-component',
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return { formFunctionCode: 'package_amount_fee_form' };
  },
  created() {
  },
  methods: {
    formComplete() {
      if (this.formConfig.code === 'view') {
        const tempData = this.formConfig.row;
        this.setValue(this.formConfig.row);
        if (tempData && tempData.photoRespVos && tempData.photoRespVos.length !== 0) { // 显示图片信息
          this.hiddenFields(false, ['photoRespVos', 'title2']);
        } else { // 隐藏图片信息
          this.hiddenFields(true, ['photoRespVos', 'title2']);
        }
        if (tempData && tempData.productRespVos && tempData.productRespVos.length !== 0) { //  显示产品信息
          this.hiddenFields(false, ['productRespVos', 'title']);
        } else { // 隐藏产品信息
          this.hiddenFields(false, ['productRespVos', 'title']);
        }
      }
    },
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'photoRespVos') {
        v.props.value = this.formConfig.row.photoRespVos || [];
      }
      if (v.field === 'productRespVos') {
        v.props.value = this.formConfig.row.productRespVos || [];
      }

      return v;
    },

  },
};
